export default __webpack_public_path__ + "static/media/keto_veggies@3x.10a88d7b.jpg";